import React from 'react';
import { variables } from 'swag-client-common/styles/variables-js';
import { SwagSvgIcon } from 'swag-client-common/components/svg/swag.svg';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { getGiveawayTypeLabel } from 'swag-common/utils/giveaway/giveaway-type.util';
import { InfoPage } from '../../partials/info-page';
import classes from './not-found-page.scss';
export const NotFoundPageComponent = ({
  params
}) => {
  const {
    giveawayType: giveawayTypeName
  } = params;
  const giveawayType = GiveawayUrl.getGiveawayTypeByLinkName(giveawayTypeName);
  const giveawayTypeLabel = getGiveawayTypeLabel(giveawayType).toLowerCase();
  return /*#__PURE__*/React.createElement(InfoPage, {
    title: "404. Page not found!",
    subtitle: `The page you are looking for doesn't exist. It is likely that the admin has ended the ${giveawayTypeLabel}, please contact them for further information.`,
    logo: /*#__PURE__*/React.createElement(SwagSvgIcon, {
      wrapperClassName: classes.logo,
      svgColor: variables.colorPrimary
    }),
    primaryColor: variables.colorPrimary
  });
};